import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApplicationsAPI } from "api/api/applicationsApi/applicationsApi";
import { ChangeDistanceAsAdminBody, ChangeDistanceAsAdminRes } from "api/api/applicationsApi/types";
import axios from "axios";
import { toast } from "react-toastify";

export const changeDistanceAsAdmin = createAsyncThunk<
  ChangeDistanceAsAdminRes,
  ChangeDistanceAsAdminBody
>(
  "applications/changeDistanceAsAdmin",
  async (body, { rejectWithValue }) => {
    try {
      const data = await ApplicationsAPI.changeDistanceAsAdmin(body);
      if (data.paymentUrl === null) {
        window.location.reload();
      } else if (data.paymentUrl) {
        window.location.href = data.paymentUrl;
      }
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        const errData = error.response?.data as { title?: string };
        const message = errData.title || "Unknown error";

        toast.error(message);

        console.error("Error while register to marathon as admin", message);
        return rejectWithValue(message);
      } else {
        const message = "Что-то пошло не так... Попробуйте обновить страницу";
        toast.error(message);
        console.error("Error while register to marathon as admin", error);
        return rejectWithValue(message);
      }
    }
  })